/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
<template>
  <div>
    <div class="indexSwiperBanner">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide
          v-for="(carouselItem, carouselIndex) in carouselList"
          :key="carouselIndex"
        >
          <div @click="linkUrl(carouselItem.url)">
            <img :src="$imgUrl.imgUrl(carouselItem.pic)" alt="" mode="aspectFill" />
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div :id="maxscrollTop ? 'commonGoTopNav' : ''">
      <div class="navBox">
        <div class="commonNavBox">
          <div
            :class="tabOpt == index ? 'tabList tabOpt' : 'tabList'"
            v-for="(item, index) in productClassList"
            :key="index"
            @click="getProductList(item.id,index,false)"
          >
            <div class="text">{{ item.catname }}</div>
          </div>
        </div>
      </div>
      <div class="navBox" v-if="secondaryClassification.length>0">
        <div class="commonNavBox">
          <div
            :class="tabOpt2 == index ? 'tabList tabOpt' : 'tabList'"
            v-for="(item, index) in secondaryClassification"
            :key="index"
            @click="getProductList(item.id,index,true)"
          >
            <div class="text">{{ item.catname }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="productBox">
      <div class="productListBox">
        <div
          class="productListPart"
        >
          <div class="productList">
            <div
              class="productItem"
              v-for="(productItem, productIndex) in productList"
              :key="productIndex"
              @click="goProductDetail(productItem)"
            >
              <img class="productImg" :src="$imgUrl.imgUrl(productItem.thumb)" alt="" />
              <div class="textArea">
                <div class="textAbbreviation2 productName">
                  {{ productItem.title }}
                </div>
                <div div class="productDec">{{ productItem.tags }}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="pagination">
					<el-pagination
						background
						layout="prev, pager, next"
					:total="1000">
					</el-pagination>
				</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import * as axios from "../../src/axios/api.js";
import imgUrl from "../../src/utils/imgUrl.js";
export default {
  data() {
    return {
      banner: {}, 
      maxscrollTop: false,
      carouselList: [
      ],
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
        },
        // 设置点击箭头
        // navigation: {
        //   nextEl: ".swiper-button-next",
        //   prevEl: ".swiper-button-prev"
        // }
      },
      productClassList: [
        
      ],
      tabOpt: NaN,
      tabOpt2: NaN,
      productList: [
        
      ],
      secondaryClassification:[],
    };
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        if (val.query.index) {
          this.index = val.query.index;
          setTimeout(() => {
            this.handleClick(val.query.index,false);
          }, 500);
        }
      },
      // 深度观察监听
      deep: true,
    },
  },
  created() {
    let id = this.$route.query.id;
    this.getProductClassList(id);
    // let index = this.$route.query.index;
    // if(index){
    //   this.handleClick(index,false);
    // }
  },
  mounted() {
    if (this.$route.query.index) {
      var that=this
      that.index = that.$route.query.index;
      setTimeout(() => {
        that.handleClick(that.index,true);
      }, 500);
    }
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    linkUrl(url) {
      window.location.href = url;
    },
    //产品分类
    getProductClassList(catid) {
      axios.get("/api/product/category",{catid:catid}).then((res) => {
        if (res.code == 1) {
          this.productClassList=res.data
          this.secondaryClassification=res.data[0].childlist
          this.getProductList(catid);
        }
      });
      axios.get("/api/banner",{catid:catid}).then((res) => {
        if (res.code == 1) {
          this.carouselList=res.data
        }
      });
    },
    //产品列表
    getProductList(catid,index,isSecondary){
      if(isSecondary!=undefined ){
        if(isSecondary){
          this.tabOpt2=index
        }else{
          this.tabOpt=index
          this.tabOpt2=NaN
          this.secondaryClassification=this.productClassList[index].childlist
        }
      }
      axios.get("/api/product/list",{catid:catid}).then((res) => {
        if (res.code == 1) {
          this.productList=res.data
        }
      });
    },
    goProductDetail(item,index) {
      this.$router.push({ name: "productDetail", query: {id:item.id,catid:item.catid,index:index} });
    },
    handleClick(index,isCurrentPage) {
      // var index = tab.index
      var that = this;
      that.tabOpt = index;
      let jump = document.querySelectorAll(".tab");
      let total = '';
      if(jump[index].offsetTop!==undefined){
        if(isCurrentPage){
          total=jump[index].offsetTop - 70;
        }else{
          total=jump[index].offsetTop - 140;
        }
      }
      let distance =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 平滑滚动，时长500ms，每10ms一跳，共50跳
      let step = total / 50;
      if (total > distance) {
        smoothDown();
      } else {
        let newTotal = distance - total;
        step = newTotal / 50;
        smoothUp();
      }
      function smoothDown() {
        if (distance < total) {
          distance += step;
          document.body.scrollTop = distance;
          document.documentElement.scrollTop = distance;
          setTimeout(smoothDown, 10);
        } else {
          document.body.scrollTop = total - 100;
          document.documentElement.scrollTop = total - 100;
        }
      }
      function smoothUp() {
        if (distance > total) {
          distance -= step;
          document.body.scrollTop = distance;
          document.documentElement.scrollTop = distance;
          setTimeout(smoothUp, 10);
        } else {
          document.body.scrollTop = total;
          document.documentElement.scrollTop = total;
        }
      }
    },
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 598) {
        this.maxscrollTop = true;
      } else {
        this.maxscrollTop = false;
      }
    },
    replace() {
      this.codeUrl = "/api/verify_code/captcha?num=" + Math.random();
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitForm() {
      axios.post("/api/product/experience", this.formSoftware).then((res) => {
        if (res.code == 1) {
          this.$message({
            message: res.msg,
            type: "success",
          });
        }
      });
    },
    getAnchor() {
      var total = this.$el.querySelector(".commonNavBox").offsetTop;
      document.body.scrollTop = total;
      document.documentElement.scrollTop = total;
    },
  },
};
</script>
<style scoped>
/* 产品 场景 */
.indexSwiperBanner .swiper-container {
  height: 520px;
}
.indexSwiperBanner .swiper-container img {
  display: block;
  width: 100%;
  height: 100%;
}
/deep/.indexSwiperBanner .swiper-slide div{
  width: 100%;
  height: 100%;
}
/deep/.swiper-pagination .swiper-pagination-bullet {
  width: 14px;
  height: 14px;
  background: #fcfcfe;
  opacity: 0.75;
  border-radius: 50%;
}
/deep/.swiper-pagination .swiper-pagination-bullet-active {
  width: 40px;
  height: 14px;
  background: #fcfcfe;
  opacity: 0.5;
  border-radius: 7px;
}
/deep/.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 48px;
}
.el-select {
  width: 100%;
}
/deep/.el-form-item__label {
  color: #333;
  font-weight: bold;
}
/deep/.codeBox .el-input {
  width: 300px;
  vertical-align: middle;
}
.sxBtn {
  position: absolute;
  left: 270px;
  width: 22px;
  height: 19px;
  top: 10px;
}
.codeImg {
  width: 99px;
  height: 38px;
  display: inline-block;
  vertical-align: middle;
  margin-left: 20px;
}
.formsBox,
#formsBox {
  padding: 0 !important;
}
.newsBg span,
.newsBg strong {
  color: white;
  line-height: 22px;
}
.newsBg strong {
  width: auto;
}
.sortNav {
  width: 1400px;
  height: 130px;
  background: #fbfbfb;
  border-radius: 12px;
  position: absolute;
  left: 50%;
  bottom: -90px;
  margin-left: -700px;
}
.productNavBox,
.secondaryNavBox {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: center;
  overflow-x: auto;
}
.productNavList,
.secondaryNavList {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 67px;
  position: relative;
  padding: 0 30px;
}
.productNavList .text {
  font-size: 14px;
  color: #666666;
}
.productNavList .line {
  display: none;
}
.navSelected .text {
  font-weight: bold;
  color: #010101;
}
.navSelected .line {
  display: block;
  width: 54px;
  height: 2px;
  background: #267fe9;
  position: absolute;
  bottom: 0px;
}
.secondaryNavList {
  height: 60px;
}
.secondaryNavList .text {
  font-size: 14px;
  color: #666666;
}
.secondarySelected .text {
  color: #267fe9;
}
.productBox {
  min-height: 90px;
  /* padding-top: 90px; */
  padding-bottom: 20px;
  box-sizing: border-box;
}
.productListBox {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin: 0 auto;
  padding: 0 8px;
  box-sizing: border-box;
}

.productImg {
  width: 100%;
  height: 332px;
  /* border-radius: 10px; */
}
.productName {
  font-size: 16px;
  font-family: Helvetica Neue;
  font-weight: 400;
  color: #333;
  line-height: 32px;
  margin-top: 12px;
}
.productDec {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  /* line-height: 42px; */
}
.textArea {
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  text-align: center;
}
.pagination {
  margin-top: 20px;
}

.navBox {
  justify-content: flex-start;
  padding: 0 180px;
  box-sizing: border-box;
  /* margin-bottom: 20px; */
}
.productListBox {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  /* padding: 0 220px; */
  box-sizing: border-box;
  overflow-x: auto;
  width: 78%;
}
.productListPart {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-content: center;
  flex-wrap: wrap;
  margin-top:60px;
}
.productList {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-content: center;
  flex-wrap: wrap;
}
.productItem {
  width: 23%;
  height: 428px;
  box-sizing: border-box;
  transition: color 0.5s;
  -webkit-transition: color 0.5s;
  /* margin: 0 12px 16px 12px; */
}
.productItem:hover {
  box-shadow: 0px 0px 23px 1px rgba(95, 95, 95, 0.18);
  -webkit-transition: color 0.5s;
}
/* .productList:hover .productNmae {
  color: #267fe9;
} */
.productItem:not(:nth-child(4n)) {
  margin-right: calc(8% / 3);
  margin-bottom: 16px;
}
.className {
  width: 100%;
  margin-top: 40px;
  margin-bottom: 47px;
  flex-shrink: 0;
  font-weight: bold;
  color: #333;
  font-size: 18px;
}
.commonNavBox .tabOpt::after{
  background-color:initial;
} 
</style>

